import axios from './http';
import { CancelTokenSource } from 'axios';
import { BillSearchResponse, BillStornoRequest, BillStornoSearchRequest } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;

export const searchStornoBills = (billStornoSearchRequest: Partial<BillStornoSearchRequest>, source: CancelTokenSource): Promise<Array<BillSearchResponse>> => {
  return axios
      .post(`${baseUrl}/api/search-storno-bills`, billStornoSearchRequest,{ cancelToken: source.token })
      .then(response => response.data);
};

export const stornoBills = (billStornoRequest: BillStornoRequest, source: CancelTokenSource) => {
  return axios
      .post(`${baseUrl}/api/storno-bills`, billStornoRequest,{ cancelToken: source.token })
};
